import React, {useState } from 'react';
import AudioItem from '../audio-item/audio-item.component';
import './audio-item-container.scss';

const AudioItemContainer = ({array, title, link, emitPauseFunc}) => {
    const [itemArray, setItemArray] = useState(array)
  
    return (
        <div className="page-container"
            >

            <div className="section-title">
                <h2>{title}</h2>
            </div>
            <div className="inner-audio-container">


                {

                itemArray.map((item, index) => {
                    return (
                        <div key={
                            item.filename
                        }>
                            <AudioItem item={item} index={index} emitPauseFunc={emitPauseFunc}/>
                        </div>
                    )
                })
            } </div>

           {    title !== "JINGLES" &&
               <div className="view-more" >
               <a 
                   href={`https://soundcloud.com/user-884790587-99361613/${link}`}
                   rel="noopener noreferrer"
                   target="_blank"
               >
               <h3>VIEW MORE +</h3>
               </a>
            </div>
           }
            
         </div>
    )
}

export default AudioItemContainer;
